import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Helper function to get auth headers
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

// Create admin user
export const createAdminUser = async (userData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/admin-users`, userData, {
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating admin user:", error);
        throw error;
    }
};

// Get all admin users with pagination and search
export const getAllAdminUsers = async (page = 1, limit = 10, search = '') => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            ...(limit !== undefined && limit !== 10 && { limit: limit.toString() }),
            ...(search && { search })
        });

        const response = await axios.get(`${apiUrlOne}/admin-users?${params}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching admin users:", error);
        throw error;
    }
};

// Get admin user by ID
export const getAdminUserById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/admin-users/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching admin user by ID:", error);
        throw error;
    }
};



export const getAdminUserProfile = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/admin-users/profile`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching admin user profile:", error);
        throw error;
    }
};

// Update admin user
export const updateAdminUser = async (id, userData) => {
    try {
        // Check if userData contains a File (image upload)
        const hasFile = Object.values(userData).some(value => value instanceof File);

        const headers = hasFile
            ? { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
            : { ...getAuthHeaders(), 'Content-Type': 'application/json' };

        const response = await axios.put(`${apiUrlOne}/admin-users/${id}`, userData, {
            headers
        });
        return response.data;
    } catch (error) {
        console.error("Error updating admin user:", error);
        throw error;
    }
};

// Delete admin user
export const deleteAdminUser = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/admin-users/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting admin user:", error);
        throw error;
    }
};

export const adminUserLogout = async () => {
    try {
        const response = await axios.post(
            `${apiUrlOne}/admin-users/logout`,
            {}, // no body
            {
                headers: getAuthHeaders()
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error logging out admin user:", error);
        throw error;
    }
};

export const getBecomeHostsAdmins = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/admin-users/become-hosts-admins`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching become hosts admin users:", error);
        throw error;
    }
};




